"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Bar = _interopRequireDefault(require("../Bar/Bar"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _wizard = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/wizard.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _wizard.default);
/** WizardFooter provides a common footer bar for `Wizard` component with a
 * "Cancel" button. It is meant to be used when building the wizard manually,
 * without the build-in logic.
 *
 * @returns {Node} WizardContent component
 */

function WizardFooter(_ref) {
  var _context;

  var children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      onCancel = _ref.onCancel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "label", "onCancel"]);
  return /*#__PURE__*/_react.default.createElement(_Bar.default, (0, _extends2.default)({
    className: classnames(className),
    rightComponents: (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)(_react.default.Children.toArray(children) || []), [/*#__PURE__*/_react.default.createElement(_Button.default, {
      compact: true,
      onClick: onCancel,
      option: "transparent"
    }, label)]),
    type: "footer"
  }, props));
}

process.env.NODE_ENV !== "production" ? WizardFooter.propTypes = {
  /** Nodes to render as extra content before the `Cancel` button */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Cancel button label */
  label: _propTypes.default.string,

  /**
   * Callback function; triggered when the cancel button is pressed.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onCancel: _propTypes.default.func
} : void 0;
WizardFooter.defaultProps = {
  label: 'Cancel',
  onCancel: function onCancel() {}
};

var _default = (0, _withStyles.default)(WizardFooter);

exports.default = _default;